import React from 'react';
import { motion } from 'framer-motion';
import { Download, FileText, Smartphone, Sparkles } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-205">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl" data-id="element-207">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight mb-6" data-id="element-208">
            Pies cómodos y saludables en 7 días — La guía simple que puedes
            seguir desde casa en menos de 10 minutos al día
          </h1>
          <p className="text-lg md:text-xl text-charcoal-light font-medium mb-6" data-id="element-209">
            Una guía digital en español para crear hábitos simples de revisión,
            higiene, confort y bienestar diario desde casa.
          </p>
          <div className="space-y-4 text-charcoal-light mb-10 leading-relaxed" data-id="element-210">
            <p data-id="element-211">
              Hay pequeños hábitos que pueden transformar la forma en que te
              cuidas cada día. Esta guía fue creada para ayudarte a incorporar
              una rutina sencilla, clara y práctica de autocuidado para tus
              pies, con pasos que puedes seguir desde casa y a tu propio ritmo.
            </p>
            <p data-id="element-212">
              Con un enfoque visual, organizado y fácil de aplicar, este recurso
              te acompaña para que te sientas con más orden, más atención y más
              tranquilidad en tu cuidado personal.
            </p>
          </div>

          <div className="flex flex-col items-start gap-4" data-id="element-213">
            <Button href="#precio" data-id="element-214">Descargar mi guía ahora</Button>

            <div className="flex flex-wrap gap-4 text-sm text-charcoal-light mt-2" data-id="element-215">
              <span className="flex items-center gap-1.5" data-id="element-216">
                <Smartphone className="w-4 h-4 text-bronze" data-id="element-217" /> Producto digital
              </span>
              <span className="text-bronze/30" data-id="element-218">•</span>
              <span className="flex items-center gap-1.5" data-id="element-219">
                <FileText className="w-4 h-4 text-bronze" data-id="element-220" /> PDF en español
              </span>
              <span className="text-bronze/30" data-id="element-221">•</span>
              <span className="flex items-center gap-1.5" data-id="element-222">
                <Download className="w-4 h-4 text-bronze" data-id="element-223" /> Descarga inmediata
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full flex items-center justify-center" data-id="element-224">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-bronze/10 border border-bronze/15" data-id="element-225">
            <img src="https://cdn.magicpatterns.com/uploads/6s6iyid9kMT5f4YaFmsjWr/PORTADA_GUIA_1777260904181.png" alt="Portada de la Guía: Rutina de Autocuidado para Pies Sensibles" className="w-full max-w-md mx-auto object-cover" data-id="element-226" />
          </div>
        </motion.div>
      </div>
    </section>;
}